webpackJsonp([1],{

/***/ "+1QT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__travel_config_inc_js__ = __webpack_require__("LvhI");



var searchTerms = {
  state: {
    keywords: [],
    searchTerm: '',
    thumbnailSrc: '',
    thumbnailActive: false
  },
  getters: {
    getKeywords: function getKeywords(state) {
      return state.keywords;
    },
    getThumbnailSrc: function getThumbnailSrc(state) {
      return state.thumbnailSrc;
    },
    getThumbnailActive: function getThumbnailActive(state) {
      return state.thumbnailActive;
    }
  },
  mutations: {
    sortKeywords: function sortKeywords(state, payload) {
      //sort keywords into an array to display on autocomplete
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_1__travel_config_inc_js__["d" /* travelSuggestions */], {
        "suggest": {
          "tag-suggest": {
            "prefix": payload,
            "completion": {
              "field": "text"
            }
          }
        }
      }).then(function (data) {
        state.keywords = data.data.suggest['tag-suggest'][0].options.map(function (option) {
          return { text: option.text, score: option._score };
        });
      }).catch(function (err) {
        console.warn(err);
      });
    },
    setThumbnailSrc: function setThumbnailSrc(state, payload) {
      state.thumbnailSrc = payload;
      state.thumbnailActive = true;
    },
    setThumbnailUnActive: function setThumbnailUnActive(state) {
      state.thumbnailActive = false;
    }
  },
  actions: {
    retrieveKeywords: function retrieveKeywords(context, payload) {
      // on load get search terms to auto complete with.
      context.commit('sortKeywords', payload);
    },
    retrieveThumbnail: function retrieveThumbnail(context, payload) {
      context.commit('setThumbnailSrc', payload);
    },
    turnOffThumbnail: function turnOffThumbnail(context) {
      context.commit('setThumbnailUnActive');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (searchTerms);

/***/ }),

/***/ "+Cjr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/qMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateFilter_vue__ = __webpack_require__("dH1Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86174fc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateFilter_vue__ = __webpack_require__("EuHx");
function injectStyle (ssrContext) {
  __webpack_require__("45jd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86174fc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0ld6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0mHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exif_date__ = __webpack_require__("6A3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exif_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exif_date__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['dateTime'],
  data: function data() {
    return {
      createdDate: ''
    };
  },

  watch: {
    dateTime: function dateTime(newval, oldval) {
      this.createdDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_exif_date__["parse"])(newval);
    }
  },
  created: function created() {
    this.createdDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_exif_date__["parse"])(this.dateTime);
  }
});

/***/ }),

/***/ "1Ujn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('md-layout',{staticClass:"header",attrs:{"md-gutter":""}},[_c('md-layout',[_c('toolBar')],1),_vm._v(" "),_c('md-layout',[_c('searchBar')],1)],1),_vm._v(" "),_c('tabBar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1sY6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.people.length)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"info-header"},[_c('b-col',{staticClass:"icon",attrs:{"col":"","sm":"1"}},[_c('img',{attrs:{"src":"static/img/people-icon.png"}})]),_vm._v(" "),_c('b-col',{attrs:{"col":"","sm":"11"}},[_c('div',{staticClass:"info-title"},[_vm._v("People")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"portraits",attrs:{"cols":"10"}},[_c('b-row',_vm._l((_vm.people),function(person,index){return _c('b-col',{key:index,attrs:{"col":"","sm":"3"}},[_c('div',{staticClass:"portrait",on:{"click":function($event){_vm.changeTag(person)}}},[_c('img',{attrs:{"src":"static/img/people-icon.png","alt":person}}),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(person))])])])}))],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","sm":"1"}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2NTX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'galleryComponent',
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['retrieveMoreImagesOfSearchTerm']), {
    infiniteHandler: function infiniteHandler($state) {
      __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].dispatch('retrieveMoreImagesOfSearchTerm').then(function () {
        $state.loaded();
        $state.complete();
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getMatchedImages'])),
  components: {
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_1_vue_infinite_loading___default.a
  }
});

/***/ }),

/***/ "2QH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__("YZHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302dfcb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__("f3/E");
function injectStyle (ssrContext) {
  __webpack_require__("p0qR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302dfcb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ZXv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2rjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['keywords'],
  methods: {
    changeTag: function changeTag(term) {
      this.$router.push('/search/tags/' + term);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getSearchTerm']))
});

/***/ }),

/***/ "3XRw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_people_vue__ = __webpack_require__("Fnt4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e30269_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_people_vue__ = __webpack_require__("1sY6");
function injectStyle (ssrContext) {
  __webpack_require__("zUy+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21e30269"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_people_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e30269_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_people_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "45jd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4B0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabBar_vue__ = __webpack_require__("NE3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc9fed0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabBar_vue__ = __webpack_require__("b1K0");
function injectStyle (ssrContext) {
  __webpack_require__("xihx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fc9fed0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc9fed0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4K7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orientationFilter__ = __webpack_require__("R58T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__peopleFilter__ = __webpack_require__("H9Vw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timeFilter__ = __webpack_require__("NtQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colorFilter__ = __webpack_require__("DX+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dateFilter__ = __webpack_require__("/qMU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tagsFilter__ = __webpack_require__("j1cm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['getFilters'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapActions */])(['changeValue'])),
  components: {
    'orientationFilter': __WEBPACK_IMPORTED_MODULE_1__orientationFilter__["a" /* default */],
    'peopleFilter': __WEBPACK_IMPORTED_MODULE_2__peopleFilter__["a" /* default */],
    'timeFilter': __WEBPACK_IMPORTED_MODULE_3__timeFilter__["a" /* default */],
    'colorFilter': __WEBPACK_IMPORTED_MODULE_4__colorFilter__["a" /* default */],
    'dateFilter': __WEBPACK_IMPORTED_MODULE_5__dateFilter__["a" /* default */],
    'tagsFilter': __WEBPACK_IMPORTED_MODULE_6__tagsFilter__["a" /* default */]
  }
});

/***/ }),

/***/ "5SsP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_galleryComponent_vue__ = __webpack_require__("t4Es");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gallery',
  components: {
    'galleryComponent': __WEBPACK_IMPORTED_MODULE_2__components_galleryComponent_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getData'])),
  data: function data() {
    return {
      displayIcon: 'portrait',
      subject: 'Taylor Host'
    };
  }
});

/***/ }),

/***/ "6+Im":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('md-toolbar',{staticClass:"md-dense"},[_c('md-layout',{attrs:{"md-align":"start"}},[_c('md-icon',{staticClass:"displayIcon md-size-2x"},[_vm._v(_vm._s(_vm.displayIcon))]),_vm._v(" "),_c('h2',{staticStyle:{"flex":"1, float: left"}},[_vm._v("Related (People, places, etc)")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('h2',{staticStyle:{"flex":"1,float: right"}},[_vm._v(_vm._s(_vm.getData.length)+" Photos")]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",staticStyle:{"float":"right, position: relative, margin: 0"},attrs:{"md-align":"end"}},[_c('md-icon',[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('galleryComponent',{attrs:{"images":_vm.getData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6zxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      highlightedPosition: 0,
      keyword: '',
      options: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getKeywords'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['retrieveMatchedImages', 'retrieveKeywords']), {
    onInput: function onInput(value) {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('retrieveKeywords', value).then();
      this.highlightedPosition = 0;
      this.isOpen = !!value;
    },
    moveDown: function moveDown() {
      if (!this.isOpen) {
        return;
      }
      this.highlightedPosition = (this.highlightedPosition + 1) % this.getKeywords.length;
    },
    moveUp: function moveUp() {
      if (!this.isOpen) {
        return;
      }
      this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this.getKeywords.length - 1 : this.highlightedPosition - 1;
    },
    select: function select() {
      this.keyword = this.getKeywords[this.highlightedPosition].text;
      this.isOpen = false;
      this.$router.push('/search/tags/' + this.keyword);
    }
  }),
  updated: function updated() {}
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9gwk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ACZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("Color")]),_vm._v(" "),_c('md-list-expand',_vm._l((_vm.colors),function(color,index){return _c('md-chip',{key:index,style:({backgroundColor: color}),attrs:{"md-editable":""}},[_c('span',{on:{"click":function($event){_vm.changed(color)}}},[_vm._v(_vm._s(color))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AUQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolBar',
  data: function data() {
    return {
      searchTerm: '',
      displayIcon: 'local_offer'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getThumbnailSrc', 'getThumbnailActive', 'getMatchedImages', 'getSearchTerm', 'getImagesCount', 'getCurrentIndex'])),
  methods: {
    backButton: function backButton() {
      this.$router.go(-1);
    },
    homeButton: function homeButton() {
      this.$router.push('/');
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.getSearchTerm) === 'object') {
      this.searchTerm = this.getSearchTerm.join(', ');
    } else {
      this.searchTerm = this.getSearchTerm;
    }
  }
});

/***/ }),

/***/ "Al55":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AuhK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showSearchBar: true
    };
  },

  methods: {
    toggleSearchBar: function toggleSearchBar() {
      this.showSearchBar = !this.showSearchBar;
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    }
  }
});

/***/ }),

/***/ "CQ4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"colors",attrs:{"fluid":""}},[_c('b-row',{staticClass:"info-header"},[_c('b-col',{staticClass:"icon",attrs:{"col":"","sm":"1"}},[_c('img',{attrs:{"src":"static/img/colors-icon.png"}})]),_vm._v(" "),_c('b-col',{attrs:{"col":"","sm":"10"}},[_c('div',{staticClass:"info-title"},[_vm._v("Colors")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"col":"","lg":"1"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"11"}},_vm._l((_vm.colors),function(color,index){return _c('div',{key:index,staticClass:"tags"},[_c('div',{staticClass:"tag",style:({background: _vm.colorToHex(color), color:_vm.isDark(color)?'white':'black'})},[_vm._v(_vm._s(_vm.colorToName(_vm.colorToHex(color))))])])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CkEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchBar_vue__ = __webpack_require__("AuhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01deb33e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchBar_vue__ = __webpack_require__("Z67u");
function injectStyle (ssrContext) {
  __webpack_require__("HgWD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01deb33e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01deb33e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DX+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colorFilter_vue__ = __webpack_require__("FKlh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e3cb5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colorFilter_vue__ = __webpack_require__("ACZZ");
function injectStyle (ssrContext) {
  __webpack_require__("kzzJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colorFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e3cb5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colorFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dozz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EBax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demoDrillDown_vue__ = __webpack_require__("xcBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3376531a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demoDrillDown_vue__ = __webpack_require__("STGv");
function injectStyle (ssrContext) {
  __webpack_require__("tlXY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3376531a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demoDrillDown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3376531a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demoDrillDown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EgUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      orientation: 2
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['editFilters']), {
    changed: function changed(value) {
      console.log(value);
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('editFilters', {
        filterKey: 'orientation',
        filterValue: value
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getFilters']))
});

/***/ }),

/***/ "EuHx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("Dates")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_vm._v("Start Date to End Date")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FKlh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      colors: ['red', 'blue', 'green', 'purple', 'yellow'],
      selectedColors: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['editFilters']), {
    changed: function changed(value) {
      var selectedIndex = this.selectedColors.indexOf(value);

      if (selectedIndex !== -1) {
        this.selectedColors.splice(selectedIndex, 1);
      } else {
        this.selectedColors.push(value);
      }

      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('editFilters', {
        filterKey: 'colors',
        filterValue: this.selectedColors
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getFilters']))
});

/***/ }),

/***/ "Fhsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_vue__ = __webpack_require__("nRVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783a4772_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_vue__ = __webpack_require__("gMT6");
function injectStyle (ssrContext) {
  __webpack_require__("+Cjr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-783a4772"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783a4772_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fnt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['people'],
  methods: {
    changeTag: function changeTag(term) {
      this.$router.push('/search/tags/' + term);
    }
  }
});

/***/ }),

/***/ "H9Vw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_peopleFilter_vue__ = __webpack_require__("kpZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218b657e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_peopleFilter_vue__ = __webpack_require__("QA6r");
function injectStyle (ssrContext) {
  __webpack_require__("amXf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_peopleFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218b657e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_peopleFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HgWD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HyGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colors_vue__ = __webpack_require__("LUfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234d34ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colors_vue__ = __webpack_require__("CQ4H");
function injectStyle (ssrContext) {
  __webpack_require__("kDqv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-234d34ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234d34ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_colors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JVw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnails",on:{"click":_vm.selectImage}},[_c('img',{staticClass:"thumbnail-img",attrs:{"src":_vm.thumbnailSrc,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K7PW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterButton_vue__ = __webpack_require__("4K7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671a85a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterButton_vue__ = __webpack_require__("WgyC");
function injectStyle (ssrContext) {
  __webpack_require__("ndxO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-671a85a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filterButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671a85a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filterButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KltS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("Orientation")]),_vm._v(" "),_c('md-list-expand',[_c('md-radio',{staticClass:"md-primary",attrs:{"id":"my-test4","name":"my-test-group2","md-value":"1"},on:{"change":function($event){_vm.changed(1)}},model:{value:(_vm.orientation),callback:function ($$v) {_vm.orientation=$$v},expression:"orientation"}},[_vm._v("Portrait")]),_vm._v(" "),_c('md-radio',{staticClass:"md-primary",attrs:{"id":"my-test5","name":"my-test-group2","md-value":"2"},on:{"change":function($event){_vm.changed(2)}},model:{value:(_vm.orientation),callback:function ($$v) {_vm.orientation=$$v},expression:"orientation"}},[_vm._v("Landscape")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LDSM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var relatedImages = {
  state: {},
  mutations: {},
  getters: {},
  actions: {}
};

/* harmony default export */ __webpack_exports__["a"] = (relatedImages);

/***/ }),

/***/ "LUfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_color_namer__ = __webpack_require__("gw7J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_color_namer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_color_namer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rgb_to_hsl__ = __webpack_require__("Ve29");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rgb_to_hsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rgb_to_hsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['colors'],
  methods: {
    changeTag: function changeTag(term) {
      console.log('you picked:', term);
    },
    colorToHex: function colorToHex(colorJSON) {
      if (colorJSON instanceof String) return colourJSON;
      var colorDec = colorJSON.color;
      var colorHex = (colorDec.red * 65536 + colorDec.green * 256 + colorDec.blue).toString(16);
      return "#" + colorHex;
    },
    colorToName: function colorToName(colorHex) {
      return __WEBPACK_IMPORTED_MODULE_1_color_namer___default()(colorHex).ntc[0].name;
    },
    isDark: function isDark(colorJSON) {
      if (colorJSON instanceof String) return false;
      var colorDec = colorJSON.color;
      var hsl = __WEBPACK_IMPORTED_MODULE_2_rgb_to_hsl___default()(colorDec.red, colorDec.green, colorDec.blue);
      return parseFloat(hsl[2]) < 50;
    }
  }
});

/***/ }),

/***/ "LXEJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LvhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return travelTagSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return travelSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return travelSingleItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return travelImageUpload; });
var travelTagSearch = "https://search-eschr-demo-kokjqkr3h4rrpfcwbrqzdrdhbu.ap-southeast-1.es.amazonaws.com/test/tags/_search";
var travelSuggestions = "https://search-eschr-tyiqhwx3brb5tglcxbocehuvda.eu-west-1.es.amazonaws.com/test/suggestions/_search";
var travelSingleItem = "https://search-eschr-demo-kokjqkr3h4rrpfcwbrqzdrdhbu.ap-southeast-1.es.amazonaws.com/test/tags/";
var travelImageUpload = "https://vynwt6nfq5.execute-api.eu-west-1.amazonaws.com/demo/upload";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555c9ffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("u2Jm");
function injectStyle (ssrContext) {
  __webpack_require__("Dozz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555c9ffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MSY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.keywords.length)?_c('b-container',{staticClass:"tags",attrs:{"fluid":""}},[_c('b-row',{staticClass:"info-header"},[_c('b-col',{staticClass:"icon",attrs:{"col":"","sm":"1"}},[_c('img',{attrs:{"src":"static/img/tags-icon.png"}})]),_vm._v(" "),_c('b-col',{attrs:{"col":"","sm":"10"}},[_c('div',{staticClass:"info-title"},[_vm._v("Things")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"col":"","lg":"1"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"11"}},_vm._l((_vm.keywords.filter(function (word) {if(word !== null){return word}})),function(keyword,index){return _c('div',{key:index},[_c('div',{staticClass:"tag",class:{blue: _vm.getSearchTerm.includes(keyword)},on:{"click":function($event){_vm.changeTag(keyword)}}},[_vm._v(_vm._s(keyword))])])}))],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N6Ce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedImages_vue__ = __webpack_require__("5SsP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393f86ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatedImages_vue__ = __webpack_require__("6+Im");
function injectStyle (ssrContext) {
  __webpack_require__("ziF4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-393f86ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393f86ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatedImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NE3k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tabBar',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progress__ = __webpack_require__("Bpc0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_touch_events__ = __webpack_require__("ufW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_touch_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_elasticsearch__ = __webpack_require__("P13P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_elasticsearch_dist_vue_elasticsearch_css__ = __webpack_require__("qVZu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_elasticsearch_dist_vue_elasticsearch_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_elasticsearch_dist_vue_elasticsearch_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_toolBar__ = __webpack_require__("pU5b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tabBar__ = __webpack_require__("4B0c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_searchBar__ = __webpack_require__("CkEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_filterButton__ = __webpack_require__("K7PW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_thumbnail__ = __webpack_require__("NYTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_relatedImages__ = __webpack_require__("N6Ce");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_tags__ = __webpack_require__("pI/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_tagChips__ = __webpack_require__("OQlx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_people__ = __webpack_require__("3XRw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_colors__ = __webpack_require__("HyGe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_dateTime__ = __webpack_require__("g7os");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_location__ = __webpack_require__("m9Ds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_autoComplete__ = __webpack_require__("z5aE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_search__ = __webpack_require__("2QH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_gallery__ = __webpack_require__("Fhsv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_store__ = __webpack_require__("wtEF");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











//Components















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('toolBar', __WEBPACK_IMPORTED_MODULE_10__components_toolBar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tabBar', __WEBPACK_IMPORTED_MODULE_11__components_tabBar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('searchBar', __WEBPACK_IMPORTED_MODULE_12__components_searchBar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('filterButton', __WEBPACK_IMPORTED_MODULE_13__components_filterButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('thumbnail', __WEBPACK_IMPORTED_MODULE_14__components_thumbnail__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('relatedImages', __WEBPACK_IMPORTED_MODULE_15__components_relatedImages__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tags', __WEBPACK_IMPORTED_MODULE_16__components_tags__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tagChips', __WEBPACK_IMPORTED_MODULE_17__components_tagChips__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('people', __WEBPACK_IMPORTED_MODULE_18__components_people__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('colors', __WEBPACK_IMPORTED_MODULE_19__components_colors__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('dateTime', __WEBPACK_IMPORTED_MODULE_20__components_dateTime__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('location', __WEBPACK_IMPORTED_MODULE_21__components_location__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('autoComplete', __WEBPACK_IMPORTED_MODULE_22__components_autoComplete__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('searchView', __WEBPACK_IMPORTED_MODULE_23__views_search__["a" /* default */]);

//Views

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('gallery', __WEBPACK_IMPORTED_MODULE_24__views_gallery__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_progress___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue2_touch_events___default.a, {
  disableClick: true,
  touchClass: 'active-touch',
  tapTolerance: 20,
  swipeTolerance: 200
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_elasticsearch__["default"], {
  suggest: {
    host: 'https://search-eschr-tyiqhwx3brb5tglcxbocehuvda.eu-west-1.es.amazonaws.com',
    index: 'test',
    type: 'suggestions'
  },
  search: {
    host: 'https://search-eschr-demo-kokjqkr3h4rrpfcwbrqzdrdhbu.ap-southeast-1.es.amazonaws.com',
    index: 'test',
    type: 'tags'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.inkRipple = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_25__store_store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
}).$mount('#app');

/***/ }),

/***/ "NYTH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_thumbnail_vue__ = __webpack_require__("YVAH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_314d6182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_thumbnail_vue__ = __webpack_require__("JVw1");
function injectStyle (ssrContext) {
  __webpack_require__("S19P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-314d6182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_thumbnail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_314d6182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_thumbnail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NtQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeFilter_vue__ = __webpack_require__("xvyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190da07f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeFilter_vue__ = __webpack_require__("U/CK");
function injectStyle (ssrContext) {
  __webpack_require__("Q6ZR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190da07f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O/is":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleItemMap_vue__ = __webpack_require__("RmUT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f6506f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleItemMap_vue__ = __webpack_require__("fJkV");
function injectStyle (ssrContext) {
  __webpack_require__("qxXW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleItemMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f6506f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleItemMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OIay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainpage',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "OQlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tagChips_vue__ = __webpack_require__("2rjo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b12c2f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tagChips_vue__ = __webpack_require__("MSY/");
function injectStyle (ssrContext) {
  __webpack_require__("a1WM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b12c2f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tagChips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b12c2f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tagChips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q6ZR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QA6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("People")]),_vm._v(" "),_c('md-list-expand',[_c('md-list-expand',[_c('md-radio',{staticClass:"md-primary",attrs:{"id":"my-test4","name":"my-test-group2","md-value":"1"},on:{"change":function($event){_vm.changed(1)}},model:{value:(_vm.people),callback:function ($$v) {_vm.people=$$v},expression:"people"}},[_vm._v("With People")]),_vm._v(" "),_c('md-radio',{staticClass:"md-primary",attrs:{"id":"my-test5","name":"my-test-group2","md-value":"2"},on:{"change":function($event){_vm.changed(2)}},model:{value:(_vm.people),callback:function ($$v) {_vm.people=$$v},expression:"people"}},[_vm._v("Without People")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qhg4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QsgM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R58T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orientationFilter_vue__ = __webpack_require__("EgUF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0edaa5fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orientationFilter_vue__ = __webpack_require__("KltS");
function injectStyle (ssrContext) {
  __webpack_require__("RmXf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orientationFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0edaa5fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orientationFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RT5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tags: ['redApple', 'bike', 'grass', 'pineapple', 'skyrim'],
      selectedTags: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['editFilters']), {
    changed: function changed(value) {
      var selectedIndex = this.selectedTags.indexOf(value);

      if (selectedIndex !== -1) {
        this.selectedTags.splice(selectedIndex, 1);
      } else {
        this.selectedTags.push(value);
      }

      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('editFilters', {
        filterKey: 'things',
        filterValue: this.selectedTags
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getFilters']))
});

/***/ }),

/***/ "Rfjh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['loc', 'places'],
  data: function data() {
    return {
      location: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getSingleImage'])),
  created: function created() {
    var that = this;
    setTimeout(function () {
      that.location = !!that.loc ? that.loc : that.places.join(' ');
    }, 500);
  }
});

/***/ }),

/***/ "RmUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['coordinates'],
  data: function data() {
    return {
      displayIcon: 'portrait'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getLatitude', 'getLongitude', 'getSingleImage'])),
  mounted: function mounted() {
    var mapboxgl = __webpack_require__("1e2d");

    mapboxgl.accessToken = 'pk.eyJ1IjoiaGVucnloYW4iLCJhIjoiY2o4YmNhY3IyMGV3ZjJ3cG1ncmw4YXBiZCJ9.arf5UU-kaFT1SOhPbzKlOA';
    var map = new mapboxgl.Map({
      container: 'image-map',
      style: 'mapbox://styles/mapbox/dark-v9',
      zoom: 9,
      center: [this.getLongitude, this.getLatitude]
    });

    var marker = new mapboxgl.Marker().setLngLat([this.getLongitude, this.getLatitude]).addTo(map);
  }
});

/***/ }),

/***/ "RmXf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S19P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SGXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__travel_config_inc_js__ = __webpack_require__("LvhI");




var searchImages = {
  state: {
    matchedImages: [],
    searchTerm: '',
    imagesCount: 0,
    size: 100,
    from: 0,
    query: []
  },
  getters: {
    getMatchedImages: function getMatchedImages(state) {
      return state.matchedImages;
    },
    getSearchTerm: function getSearchTerm(state) {
      return state.searchTerm;
    },
    getImagesCount: function getImagesCount(state) {
      return state.imagesCount;
    }
  },
  mutations: {
    sortMatchedImages: function sortMatchedImages(state, payload) {
      state.searchTerm = payload.result;
      state.from += 100;
      state.imagesCount = payload.data.hits.total;
      state.matchedImages = payload.data.hits.hits;
    },
    retrieveMoreMatchedImages: function retrieveMoreMatchedImages(state) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_2__travel_config_inc_js__["b" /* travelTagSearch */], {
        size: state.size,
        "query": {
          "terms": {
            "keywords": state.query
          }
        },
        from: state.from
      }).then(function (data) {
        state.from += 100;
        state.matchedImages = state.matchedImages.concat(data.data.hits.hits);
      }).catch(function (err) {
        console.warn(err);
      });
    },
    changeSearchTerm: function changeSearchTerm(state, payload) {
      state.searchTerm = payload;
    }
  },
  actions: {
    retrieveMatchedImages: function retrieveMatchedImages(_ref, payload) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state;

      state.from = 0;
      state.query = payload.result.split(',');
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_2__travel_config_inc_js__["b" /* travelTagSearch */], {
        size: state.size,
        "query": {
          "terms": {
            "keywords": state.query
          }
        },
        from: 0
      }).then(function (data) {
        commit('sortMatchedImages', data);
        if (payload.thumbnail === false) {
          dispatch('turnOffThumbnail');
        }
      }).catch(function (err) {
        console.warn(err);
      });
    },
    setSearchTerm: function setSearchTerm(context, payload) {
      context.commit('changeSearchTerm', payload);
    },
    retrieveMoreImagesOfSearchTerm: function retrieveMoreImagesOfSearchTerm(context) {
      context.commit('retrieveMoreMatchedImages');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (searchImages);

/***/ }),

/***/ "SKUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demoView"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"id":"miro-logo","cols":"12"}},[_c('b-col',[_c('img',{staticClass:"miroImg",attrs:{"src":__webpack_require__("uNZE"),"alt":"miro"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"id":"tag-line","cols":"12"}},[_c('h1',[_vm._v("Add Visual Search to Your APP or Project in "),_c('u',[_vm._v("Minutes.")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"searchArea searchBar v-center",attrs:{"cols":"12"}},[_c('b-col',{staticClass:"searchButton",attrs:{"sm":"10","lg":"10"},on:{"click":function($event){_vm.openDialog('searchDialog')}}},[_c('b-row',{staticClass:"input-row"},[_c('b-col',{staticClass:" v-center search-icon",attrs:{"sm":"1","lg":"1"}},[_c('img',{attrs:{"src":__webpack_require__("mtD8"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticClass:"blinking-cursor",attrs:{"cols":"1","align-self":"center"}},[_vm._v("|")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2","lg":"2"}},[_c('label',{staticClass:"image-upload-icon",attrs:{"for":"file-input"}},[_c('img',{attrs:{"src":__webpack_require__("dZpC"),"alt":""}})]),_vm._v(" "),_c('input',{staticClass:"image-upload",attrs:{"type":"file","id":"file-input"},on:{"change":function($event){_vm.uploadImage($event)}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"searchArea v-center",staticStyle:{"height":"5em"},attrs:{"cols":"12"}},[_c('b-col',{staticClass:"searchButton",attrs:{"sm":"11","lg":"10"}},[_c('b-row',{staticClass:"input-row"},[_c('b-col',{attrs:{"cols":"1"}}),_vm._v(" "),_c('b-col',{staticClass:"blinking-cursor",attrs:{"cols":"1","align-self":"center"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"1","lg":"2"}},[_c('img',{staticClass:"search-by-image",attrs:{"src":__webpack_require__("YKjc"),"alt":"Search by Image"}})])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"image-upload-screen"},[_c('b-row',{staticStyle:{"position":"absolute","bottom":"20%","top":"20%","width":"100%"},attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"10","align-self":"start"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('canvas',{attrs:{"id":"cvas","width":"2000","height":"3000"}}),_vm._v(" "),_c('img',{attrs:{"id":"hideimg"}})]),_vm._v(" "),_c('img',{staticClass:"thumbnailImg",attrs:{"src":_vm.thumbnailSrc,"alt":""}}),_vm._v(" "),_c('progress-bar',{ref:"basicLine",staticClass:"line",attrs:{"type":"line","options":_vm.options}})],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"searchDialog",staticClass:"searchDialog",attrs:{"md-open-from":"#searchButton","id":"search-dialog"}},[_c('searchView',{attrs:{"close-button":_vm.refss}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SPK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ParseDMS(input) {
  var parts = input.split(/[^\d\w]+/);
  var lat = ConvertDMSToDD(parts[0], parts[1], parts[2]);
  var lng = ConvertDMSToDD(parts[4], parts[5], parts[6]);
}

function ConvertDMSToDD(degrees, minutes, seconds, direction) {
  var dd = degrees + minutes / 60 + seconds / (60 * 60);

  if (direction == "S" || direction == "W") {
    dd = dd * -1;
  } // Don't do anything for N or E
  return dd;
}

var singleItemMap = {
  state: {
    longitude: null,
    latitude: null
  },
  getters: {
    getLongitude: function getLongitude(state) {
      return state.longitude;
    },
    getLatitude: function getLatitude(state) {
      return state.latitude;
    }
  },
  mutations: {
    setCoordinates: function setCoordinates(state, payload) {
      state.latitude = ConvertDMSToDD(payload.GPSLatitude[0], payload.GPSLatitude[1], payload.GPSLatitude[2], payload.GPSLatitudeRef);
      state.longitude = ConvertDMSToDD(payload.GPSLongitude[0], payload.GPSLongitude[1], payload.GPSLongitude[2], payload.GPSLongitudeRef);
    }
  },
  actions: {
    retrieveCoordinates: function retrieveCoordinates(context, payload) {
      context.commit('setCoordinates', payload._source.exif.gps);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (singleItemMap);

/***/ }),

/***/ "STGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('toolBar'),_vm._v(" "),_c('gallery')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U/CK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("Time of Day")]),_vm._v(" "),_c('md-list-expand',[_c('md-list-expand',[_c('md-radio',{staticClass:"md-primary",attrs:{"id":"my-test4","name":"my-test-group2","md-value":"1"},on:{"change":function($event){_vm.changed(1)}},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_vm._v("Day Time")]),_vm._v(" "),_c('md-radio',{staticClass:"md-primary",attrs:{"id":"my-test5","name":"my-test-group2","md-value":"2"},on:{"change":function($event){_vm.changed(2)}},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_vm._v("Night Time")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WgyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('md-dialog',{ref:"filterDialog",attrs:{"md-open-from":"#filterButton"}},[_c('div',{staticClass:"phone-viewport"},[_c('md-toolbar',{attrs:{"md-theme":"white"}},[_c('span',{staticClass:"md-title"},[_vm._v("Categories")])]),_vm._v(" "),_c('md-list',[_c('orientationFilter'),_vm._v(" "),_c('peopleFilter'),_vm._v(" "),_c('timeFilter'),_vm._v(" "),_c('colorFilter'),_vm._v(" "),_c('dateFilter'),_vm._v(" "),_c('tagsFilter')],1)],1)]),_vm._v(" "),_c('md-button',{staticClass:"md-fab row",attrs:{"id":"filter","md-fab-trigger":"","md-theme":"white"},on:{"click":function($event){_vm.openDialog('filterDialog')}}},[_c('md-icon',{staticClass:"col-xs-3 filterIcon"},[_vm._v("filter_list")]),_vm._v(" "),_c('label',{staticClass:"filterText col-xs-9"},[_vm._v("Filter")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XH0R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"autocomplete-input-template"}},[_c('div',{staticClass:"autocomplete-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],ref:"autocompleteRef",attrs:{"type":"text","id":"autocompleteTextField","value":"text field","autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false","role":"textbox"},domProps:{"value":(_vm.keyword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value},function($event){_vm.onInput($event.target.value)}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.isOpen = false},"blur":function($event){_vm.isOpen = false},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }_vm.moveDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }_vm.moveUp($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.select($event)}]}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"options-list"},_vm._l((_vm.getKeywords),function(option,index){return _c('li',{class:{
          'highlighted': index === _vm.highlightedPosition
          },on:{"mouseenter":function($event){_vm.highlightedPosition = index},"mousedown":_vm.select}},[_c('div',{staticClass:"autocomplete-option"},[_c('b-row',{staticClass:"optionText"},[_c('b-col',{attrs:{"cols":"*","sm":"1","md":"1","lg":"1"}},[_c('md-icon',{staticClass:"md-size-2x optionIcon"},[_vm._v("search")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"*","sm":"9","md":"9","lg":"10"}},[_vm._v(_vm._s(option.text))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"*","sm":"2","md":"2","lg":"1"}},[_vm._v(_vm._s(option.score))])],1)],1)])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XHkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"info-header"},[_c('b-col',{staticClass:"icon",attrs:{"col":"","sm":"1"}},[_c('img',{attrs:{"src":"static/img/location-icon.png"}})]),_vm._v(" "),_c('b-col',{attrs:{"col":"","sm":"10"}},[_c('div',{staticClass:"info-title"},[_vm._v(_vm._s(_vm.location))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YKjc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/searchByImage.2751204.png";

/***/ }),

/***/ "YVAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_config_inc_js__ = __webpack_require__("pbG7");

//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'thumbnail',
  props: ['image', 'index'],
  data: function data() {
    return {
      thumbnailSrc: '' + __WEBPACK_IMPORTED_MODULE_4__images_config_inc_js__["b" /* thumbnailImage */] + this.image._source.resource_id + '.jpg',
      imgSrc: '' + __WEBPACK_IMPORTED_MODULE_4__images_config_inc_js__["a" /* fullImage */] + this.image._source.resource_id + '.jpg'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['selectSingleItem']), {
    selectImage: function selectImage() {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('selectSingleItem', {
        imageSrc: this.imgSrc,
        image: this.image,
        currentIndex: this.index
      });
      this.$router.push({ name: 'singleItem', params: { id: this.image._source.resource_id } });
    }
  })
});

/***/ }),

/***/ "YZHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchTerms: [],
      selectedTerm: '',
      routeName: this.$route.name
    };
  },

  props: ['closeButton'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['retrieveKeywords', 'retrieveMatchedImages']), {
    termFilter: function termFilter(list, query) {
      var arr = [];
      query = query.toLowerCase();
      for (var i = 0; i < list.length; i++) {
        var term = list[i].name;
        if (term.indexOf(query) !== -1) {
          arr.push({ name: list[i].name });
        }
        if (arr.length > 5) break;
      }
      console.log(arr);
      return arr;
    },
    closeDialog: function closeDialog(ref) {
      this.closeButton[ref].close();
    },
    onChange: function onChange(value) {
      this.$store.dispatch('elastic/suggest/fetchSuggestions', value);
    },
    onSelect: function onSelect(keyword) {
      this.$router.push('/search/tags/' + keyword);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getKeywords']), {
    suggestions: function suggestions() {
      return this.$store.getters['elastic/suggest/suggestions'];
    }
  })
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mainpage__ = __webpack_require__("sFPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_singleItem__ = __webpack_require__("ovQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_demo__ = __webpack_require__("zH4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_demoDrillDown__ = __webpack_require__("EBax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

/* top level filters - should probably be included from elsewhere */
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()(String(value)).format('LLLL');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [
  // {
  //   path: '/',
  //   name: 'mainpage',
  //   component: Main
  // },
  {
    path: '/image/:id',
    name: 'singleItem',
    component: __WEBPACK_IMPORTED_MODULE_4__views_singleItem__["a" /* default */]
  }, {
    path: '/',
    name: 'demo',
    component: __WEBPACK_IMPORTED_MODULE_5__views_demo__["a" /* default */]
  }, {
    path: '/search/tags/:tags',
    name: __WEBPACK_IMPORTED_MODULE_6__views_demoDrillDown__["a" /* default */],
    component: __WEBPACK_IMPORTED_MODULE_6__views_demoDrillDown__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Z67u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('md-toolbar',{staticClass:"md-dense"},[_c('md-layout',{attrs:{"md-row":""}},[_c('md-layout',{staticClass:"icons",attrs:{"md-align":"end","md-flex-xsmall":""}},[_c('md-button',{attrs:{"id":"search"},on:{"click":function($event){_vm.openDialog('searchDialog')}}},[_c('md-icon',{staticClass:"searchIcon"},[_vm._v("search")])],1),_vm._v(" "),_c('md-icon',{staticClass:"md-size-2x"},[_vm._v("camera_alt")]),_vm._v(" "),_c('md-icon',{staticClass:"md-size-2x"},[_vm._v("import_export")])],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"searchDialog",staticClass:"searchDialog",attrs:{"md-open-from":"#searchButton","md-close-to":"#custom"}},[_c('searchView')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a1WM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a9B1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['chips', 'bgcolor', 'icon'],
  data: function data() {
    return {
      keywords: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getSingleImage'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['retrieveMatchedImages']), {
    changeTag: function changeTag(term) {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('retrieveMatchedImages', { result: term, thumbnail: false });
    }
  }),
  created: function created() {
    this.keywords = this.chips.filter(function (word) {
      if (word !== null) {
        return word;
      }
    });
  }
});

/***/ }),

/***/ "amXf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b1K0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-tabs',{attrs:{"md-fixed":""}},[_c('md-tab',{attrs:{"id":"time","md-label":"TIME"}},[_c('gallery',{attrs:{"name":"time"}})],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"people","md-label":"PEOPLE"}},[_c('gallery',{attrs:{"name":"people"}})],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"places","md-label":"PLACES"}},[_c('gallery',{attrs:{"name":"places"}})],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"things","md-label":"THINGS"}},[_c('gallery',{attrs:{"name":"things"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "br4N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d0JZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},_vm._l((_vm.keywords),function(keyword,index){return _c('div',{staticClass:"chip",style:({background: _vm.bgcolor})},[_c('span',{on:{"click":function($event){_vm.changeTag(keyword)}}},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(keyword)+"\n    ")],1)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dH1Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "dZpC":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAACgCAYAAABJ/yOpAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTZBNDIxMjJBNzRCMTFFN0FBREREQUMzN0UwQUU3NzYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTZBNDIxMjFBNzRCMTFFN0FBREREQUMzN0UwQUU3NzYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2NDhCNzBEQTkzOTgxMUU3QjkyREVBQzAyRDJDNDE2NyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2NDhCNzBEQjkzOTgxMUU3QjkyREVBQzAyRDJDNDE2NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pk8vxcwAABS1SURBVHja7F0HlBbVFb7Lv7SFuIiIDRUrig1RiQUFe8deYrDHGnusR0QBwYK9xZJY0WiiiL3rqrFj76CoSBSRrsACW/I+3v0FYXfnzuybf2be3O+cezhnmX/Km/fNu+/Wsmn9ziJFk+hoZKCRgpF6j56rrZGnjIzUV2xRP2sOtdlvW2p7wr6//a1chyUQJxk51dNn62vkZSNT9DU3jBY6BE2im5GzPX6+NY2cr69ZCRIVQ4208/wZTzCyob5qJUhY7Gxk3xw8Zxsjw/R1K0HCoJWRS42U5eR5dzeyt752JYgUxxnpkUN1sq2+eiVIEFY0MiCHz92d/LXWKUEc4gIjnXP67OcYWVWngBKkMWxm5OgcP38HIxfpNFCCNARsyC8x0jLn43CYkd46HZQgi+MgI9vrMCyYE/hQFHQolCBF/MHIYB2G34AV5FAdBiVIEX8zspYOw+8wyMgyShAF4pHO0GFYAquQ33FoShAhhrCKpVgSJxtZTwmSX+zAm3NFw4BnfZgSJJ+AORfWmjLlQZPoZ2Q3JUj+8Bcjm+r8FwGBm22UIPkBQkku0HkvxgZG/qoEyQ+QRbeCzvtQgEVrJSWI/9jYyLE63yOtuhcpQfzHJXnVpx3gCCObK0H8xf5kU2kV0VDOG/aCEsQ/wBl4sc7xZqOPkT8pQfwDvMLddH47AQI7OyhB/EFXI1pC0h1WM3JmXnRKV4BeimogaUo4quePwNC8fPFKCOSvP2zk85S981oj81gSJcjyRrYka9VYl6yNfGkjrVP2Isv4XhVu0d5IlZGZKdNEQJBfjEwyMs7Ie0ZeM/KRkZq4CYJVYhcj/ckG+nXSeZJ7krRP6b2tY2QbsqbpOiPvGnnAyP1G/hfHHgQBa68aedzIwUoORcb22ijIcQUTBUaGZVwRBOrJHUaeMLKFjrUi41iObBze6ySoJhlEEBDiJV6mFAqfsDYbGQY3xYOmCAJ2Pc26nELhK7Ca3EONhB81tknfw8i/SGOWFPnAIWRN1YgQqA1aQTYycq+SQ5EzHGBkOBUKTapYlUZGGFlKx0uROxRanF43aWr/pgiCWkjr60gp8oiy1q1o/hufXF3z0diVGyLIJkZO1GFS5JchZUR19Z1mX3n/RfXVc5cgyADSws2KvKNVOdVOmHTovKff2nBRgkCt2l1HR6EwC0nLQst5z7+zQJsqmnkP0tWjpIApcaqRaUZ+NTLHSLURrOv1/F5gRUThNnTZhdGkI/nfcTclq0hLqh0/ce+aL8cPKL6IXXVUYsN0I1+QDQv/xMhYI98wOX5hcsxv7GPGJKlgkiBieg2y0dMb8L9ddYjd70XqZ1cvN3fUK9uAIAhX18rm7oA8hA+NvGzkFbLh1hNpMQeUEFhNZrNMJhu+/eoi/1/J7w4hQduSTT9YTl+BAxQKVD91xnYgSB9Sv4cLleltI6OMPMMrRW0JrjvDyGiW640sa2RrI/uQTUvQiOuoi0jrllQz9vuexRVEEQ0/GXmQbOTBGym4n5+NjGSBOrYX2UY4+o6joKZ2BVix1tSRCI2vyVYahO/opJSQY3EgKegmst2idjLyCNnEIYV8L9KhBS/LChmwBzidbNHr4RQiMy1h9e85stHZ6MH4mL5GMdpCxWqt4xAI5F1fw3r+5Aw/RxULfF4DMqJ6jeH93Y9ka5ttwPddiuJ15eU69wOBjfcFvPH2BcgOfZZsxfbzU7qZhyl8IO+nZi+q+BjpxQTfI3Yta1q/s2CH19D2JTGRJ8/tMV4D1kM4/9rySo6ySVB7YSqGb2QOywxq3FfSXKzF6uJeKRr7j/h+vm1q7hq5yshpcaqnuoI0jCfJVmIc5+pDZGR1so49xPh0J1t8DV/uSiYJPlLli+wb5vOXE572KaxifMErGSbQV0yc5mIs708w0QZT8v0aEWFwcAA5APiI0HwVjtM9dQUpDWDlQZG5QdR8PwZWBzjwdiTrxANBOji8z+/IOiGhKsEp+aWD8+J+UaAjyRKtIOmFIY5HHOHomPbStUqQhcBX+hiyifzNWSn68BcQjrpVS3TvCFl508h/yFqpJjbjXPDE30yCih8xAHMR5Xk+Dfm7F/kj5Jwg2gbaAqrUzs0gB9SSw438l2wVmONKSI7i9bFS3WrkAyPXkk2djgI4P5F+emMC7+HHiGrt+3HdkBLEqimoEvluhN+iqiDCot8xcifZWKikgRXgFF5R7opIFJToPCmkquNqBamO8LuZSpB4AA84KkZ+E+G3B/Hvb6R0tlWA2nwY2QJpV1O0nozYD5xewnuujGgk6KwEcY+3yJoSfwr5O5ABvpH7KRv5+wiVP41XyCMj/P6aEpIEVTy7R9j3ba4EcQtsAvclG9wXBsex6rJXBp8ZKwh8Og9R+BwSkKQUbbPL2VASBth7bawEcYfvyYaD/xDiNyh0fB9Z607W+4zgw4CckrAp1mhfd30J7u/QEPeGdhvDeRVRgjgAzKGonjc2xG96kvUz+NSXrwvZ6N6wqwIccyNjvjekft9N1kwetCLCrL1hnDeTN4Ig9ui1EMcjTByOuPU8HIsCb8JvJXk9Ali3jqL449I6MoGvI2uFW9RPtwpZyyHe4/ZxD1KeHIXXUri4nQP4S5aHscG+BBav2cLje/CqWopMVMSlIawGISiIWYN/qVTBlbmJxYKf4twQx6P85B3ktodjmrEfT74DjcwSHA9n5Jm8+sQNBHB2T2pg8qBizWLLiNQBhU3s7TkiRxHwB93DE1KC23gP4DXyQJAhZKuMSNCX1aq81giDde/mkJv2iUqQbKtWVwmPRaMg9ETJe3E2OBMHCY+dQDZnRgmSQdSwnixJNGrHK4e2i7YYyKuJBHeSTeNVgmQMWA1eER6LVWazFBAaFkVYkmC5qU/4fm4hWcUb5KacR/FlPCYKXzei2JhfLDwWFpxjS3x/0NsRG4VIYmQJwrs/le8bEw7JP5W8oiHzEGZVlBhaN8QmurlYlvcjuwomP8Jv0IO8vxIkG4CJdozgOESBXleiewIBHiXriUaE7ZQI7woVPeBh3p+shz9uwBEH5+o1gmMvoYXmYlWxUoxfhC8UGGZkxZjvB0lAF/CExgb4sQjkKKpg7/NERPQq4pWeLsF4IidkDcFxnxn5t+5B0g+8pK8Fx21J0cK/pYDfZTirRlD3vnN4bqg8T7L6g6/2xzE+B4IzBwuPvY6JrARJKWpJZsdH9OfQGJ8fewuk8J7NK0icGMlkvzLGayDHvrfwuZ9XgqQXsFqNFhwHr3HfmO4B5uJtSW5BcwGUBoJJG6Eik2OaJ9LI31uVIOnF3cLV45yYrg//AYo3zEzo+RH6gQSir2I4N87bR3Dcc0IVVwlSYiA78AnBcdsI1YWwgDo1JAXj8AGvkGMdnxcfllOEq9koJUj68BzJUmhPIPcZaMN4Q54WgBzwhE9yfF4Qb13BceiZUqcESRckXy3kErjux4hcijTGI33K6t48h+dEbswhwlXsCyVIegAnnCRTEKHsLpN84Iw8LsXjAj/JIMfnRCJZkDMQJu4XlSDpAcyLPwie1WU5TZiUUVxtSsrH5nKyFR9dAWWPeglVXiVISvCy4JjVhS9WihEZmQRw3J3hWNWS9OXAR2uaEiR5IOr1LcFxfchdfjnMuIMzNEbIi7nP4fn6UnAc3wQf9iE+EGS68EW4rP6N1WNcxsbpCiNzHZ0LpXZWExz3rhIkeXxLwc00ET7ew9H1EAd1cwbHCVatpxydCyH3mwiO+0AJkjywegTZ3FFLaS2H+52PMzpWdzo8lyTBbAxl3B/iA0EkYRXrkLtEo4czPFZVvDdwgXUExyARbJYSJP0EWdvRtWDffyHDY4Wehq5MvmtScNszZE5OUoIkC0k4+RqOrjWGgptLph2uCIJGPUF9Oaop/nB/JUjAhnmq4LiVHF0PNWnnZnzM4J9wURAClWAkVWB+VoIkh3kka4Xc0dH1PvdgxZ0g/KgEAX6QpQXHTVeCJLuCBBVcRhXzSoeTK+uY7ogggKRdmm7SEyZItYAgriptTPGAILMcTtoKwTGzlSDJoYaCazZBFXDVZP4XDwhS53DSSkJ3qpUgyUGy2SwjdwlS9eQH6ko4f+qVIMmhQMFBczXkLpK1whOCuFI55wiOaaUESQ6tBOpTrcNlfmlPyOGqgr1kXCuUIMmhXPA1BEFcVRlZ0QOCVJI7q55kT9ZOCZLsChKUQgsd2JUtfm0PCAIPuIsef3XCD89SSpDkAPVK4gR0Fe6wPu97sgwUwHbRQQv7D0l3qU5KkGTRWXDMN46uhZI3K2R8vLZydJ4pAoKUZ328fCDI6oJjvnR0LRRy3jLjK+42js6FjMoghyN6jCyvBEkWkkhdl4k7e2d4rIpNeFxA8tFZWfcgyUOSuINasd87uh4Kz2XVmvVncuc0fU+4uheUIMmvIMsEHANz5EcO1axDMzhOsF4d6OhcsAxKquhvlPXJ5QNBoOdKzK+vOrwm6vtWZmycUAHSlUUJWZyS0P+eSpDkgSV8U8FxLzjch6DG78kZGqMuju8XH5ugMBOY3zdQgqQDkr4VKHvzicNromHNWhkZnyHk1h8haTOB2lnLK0HSgV4ClQepsk86vCaud30GNqGwuh3u8HzwfVQJjutL7ttMKEEiAuZESSEzdGBy2fAefQjPT/G4oPLITY4nKlaPqYJ5tZMPE8un/iD9BMegjfIbjq97Edm+5WkD0mHvJbeebFivJG3uYDTpoQRJF9A3vELwgm9xfF18nW83sn2KxgKZfiPIbTV74E0jrwuO25Pc5ZwoQRyqE5IwClRGHBPD1xqdpnZJycpxv3BFDYsbKLgPOuKvDvBlUvnW5fYwwTEwT14Xw7UrmXzHJ/j8UG1QoHqvGM79CX8EgvBH4X5QCZIAsLSvKjjuLoqnVTJUm7+zGrdsiZ8d7eVeInfRuovjMpIVzTvSp3nlG0Ha8wsKwq+8uY4Lx5KtAl+KwEb06fgnf93jihF7k9W2IHRJqcFCCbIIjiZZ7jhe+Csx3se6rHLB97JdDOcHGQby5D0qxudA9MG5gr1H8cNQqQRJN7oIJwxy1U+l+Os2IfoXYS5VTN7m1AmuYEPEjWS7N6GDbeeY7/9WkvWA7MwE8Qrl5Ccw8WF6DWoiiQ5Il5D7VskNoQ/LZCNvk41nQu/A8WSz8xBxXHRiljEZEDmMKFzENG3J+4v1SjiOX/MqJcFJfK9eoWxav7PmkLvmlmnCIOE+Ax8J9PTeOqH7nMlERnbebF7Z2jBBluLNfhIrPVQq+JaeFRyLDl5wwnb0bA7V+rqCFFcReH3HCSYCNvavl0BdaQhLUTqz7oYIyQFc6CE5vN2DFAH1ZFgIVeJo/noriB5hgkhVx8N8HYgWnr/og0juNHvcyBnKjQX7oiNIVlMX4SRXeryX9Z4gwDUkz4WAh31ojsmBQgzwY0gL7cH8u4nPA5IHgnQ1cnWI4wcYuTaH5PiWrGNzvPD4rZkgpATJPvrzHkOK04wMzxE5ELwJf80XwuOxIf8HZbxyuxJkSVVr0xDHn82rie+Aw3HnEOQAbiM/6hQrQRYB4rSQIxEmXgn7kWNI1gcji4BhYhcK19oajsN98zJp8kQQoBuTJEzPCqgSO4b8wqYdiK8awhN9cojfHUHxBnkqQVKAbY3cSeGKLbxG1t5/lwfPj0Le+/BKECY/H151hPGXKUH8BzLewhYzmMRf0P4hVZI0Aash4rkeDfm7vkbuy8OmXAmyEIg8vSHC7+7lSQafydyMPCsKVezG+6mwvVKwcj5IGS9CrQSJhhPJRv2GbSjzA9lYr634yzo/pc/3GZMCk/ypCL8HqUZRcO1jJYjHOJK/kB0i/BYmUlRM781Em56SZ0K4CGrxbsFqVRQCI77qoYjjogTxDKgAgsy/1SP+HvkdcETCz4JCch8m8AzYI43grz5WNiQ6RW1eeh4bMtrkfWL4nA8SBRPIViV5opnnac1kwWSF1WzjmMYYxoLXWX16kVW/5gAecmQrHqxTYQG8zgeJAqTrItQbyVbINKyJeB5s3l9jKfDK1JNJ051s0WtUPGxLMnNzNatvMNEiLATNa9CfAwW5Zzh6dqhjsOz10GmgK4gEzxs5i2xarmtgvJGctSJ/tWEhquC/F5hg1awiQWB5mshkqHN8L/hIolL9QPKkGqKuIKXBDmTrTCHp6npyW9wB5xpP8sjZuLAVr5Rb6+tufJNepsPQKGDBuZxseaBdPHouqJJX8yqp5AggyHwdhkBsxhthtE/oleHnQOLYOWStbqepah2sYoEg03QcxNifN94PUHwlPuNAZ95PgRiXktuWCD5jLgjynY5D6E0tusWirhWqfhxM6Q3DQDrsVWRL8kBVXE1fXyjMxMuGubC3jkVoYO+2IwsKYSMA8GEez+oE7wvFu3fl1a4PeVxQIXbU1U3C4KGs5PGqjzYL6E1yBgvaBMD69RxZE/H3MV+7nZF1mAw78R5paX0lzUP9vBoq77bKp+WsKsDcuLYOixOsz4K2yz+TTbQazWQZy2P9E0VzQsKqBt9JV7LlSOF47MGqU0GH3uX2vJbKKttXgSCoC1ulBIkFy7IUTakoTDedCVJ0/sFIgrq8s1k1Qz0qRBdX8OqAaumdeGO9Eq8OFTq0cSvQZbNa7bDZS0X9FK0AjtVRiR34yi/D0l2HI6WYX0OFLp1faNV7w3HFaF44wt7RkVEosP+YTy17db/JrCK/hbtj6b9Uh0aRe9TUUov27apa79d3QeHuRfNBRlK0rDOFwif1qqbNUbuf26JTh/rFCQKcTunJilMoSgujWpWvv8YVrffY6q3inxYnCIoXH68jpcjn3qPm+UL3roOoxUJaNJRyizijgTpcipzhMyqj/kbF+l0URGM56ai6N1THTJETIPoBdQl+Wvw/miragMLN8AZX6/gpPMYzZIt3f93QfwZVNUFhtd2ZYQqFT0Ae1GVG9qAmil1Iyv6gWkZvVrlm6LgqPAD61m9PtgFQkzFx0rpYM1jlQmbdpY0tRwpFioF4t1G8YqDewKuSH4XNFUA0KoqKoZABGttvRza8GjnOqM5RwefUPHdFUqijhRVhUEwP5VcRSlVFtmRSKPxfgAEAKnbez0SNnzkAAAAASUVORK5CYII="

/***/ }),

/***/ "ewz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("Tags")]),_vm._v(" "),_c('md-list-expand',_vm._l((_vm.tags),function(tag,index){return _c('md-chip',{key:index,attrs:{"md-editable":""}},[_c('span',{on:{"click":function($event){_vm.changed(tag)}}},[_vm._v(_vm._s(tag))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f3/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"searchHeader"},[_c('b-row',{staticClass:"insideHeader",attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"1","align-self":"start"}},[_c('md-button',{staticClass:"backButton",on:{"click":function($event){_vm.closeDialog('searchDialog')}}},[_c('md-icon',{staticClass:"md-size-5x"},[_vm._v("keyboard_arrow_left")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"magnifying-icon",attrs:{"cols":"2","align-self":"start"}},[_c('img',{attrs:{"src":__webpack_require__("mtD8"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticStyle:{"margin-top":"1em"},attrs:{"cols":"9","align-self":"start"}},[_c('vue-elastic-autocomplete',{attrs:{"suggestions":_vm.suggestions,"id":"autocompleteInputField","suggestionClass":"ve-autocomplete-suggestion"},on:{"changed":_vm.onChange,"selected":_vm.onSelect},scopedSlots:_vm._u([{key:"suggestion",fn:function(ref){
var suggestion = ref.suggestion;
return [_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"1"}},[_c('md-icon',{staticClass:"md-size-2x optionIcon"},[_vm._v("search")])],1),_vm._v(" "),_c('b-col',{attrs:{"align-self":"center"}},[_vm._v("\n                "+_vm._s(suggestion.text)+"\n              ")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2","lg":"1"}},[_vm._v("\n                "+_vm._s(suggestion.score)+"\n              ")])],1)]}}])},[_c('template',{attrs:{"slot":"input-box-header"},slot:"input-box-header"}),_vm._v(" "),_c('template',{attrs:{"slot":"input-box-footer"},slot:"input-box-footer"},[_c('i',{staticClass:"fa fa-search"})])],2)],1)],1)],1),_vm._v(" "),(_vm.routeName !== 'demo')?_c('div',{},[_c('md-layout',{attrs:{"md-gutter":""}},[_c('md-layout',{staticClass:"imageIcons"},[_c('md-button',[_c('md-icon',{staticClass:"md-size-2x"},[_vm._v("camera_alt")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"imageIcons"},[_c('md-button',[_c('md-icon',{staticClass:"md-size-2x"},[_vm._v("portrait")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"id":"grey-miro"}},[_c('b-col',{staticClass:"text-center",attrs:{"col":"","align-self":"center"}},[_c('img',{staticClass:"grey",attrs:{"src":__webpack_require__("uNZE"),"alt":"miro"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center grey",attrs:{"col":""}},[_vm._v("\n          Try some search terms like "),_c('strong',[_vm._v("Colombia")]),_vm._v(" or "),_c('strong',[_vm._v("Sunset")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fJkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('md-toolbar',{staticClass:"md-dense"},[_c('md-layout',{attrs:{"md-align":"start"}},[_c('md-icon',{staticClass:"displayIcon md-size-2x"},[_vm._v(_vm._s(_vm.displayIcon))]),_vm._v(" "),_c('h2',{staticStyle:{"flex":"1, float: left"}},[_vm._v(_vm._s(_vm.getSingleImage._source.places[0] || 'Location'))])],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"image-map"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g7os":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateTime_vue__ = __webpack_require__("0mHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb270f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateTime_vue__ = __webpack_require__("oeLn");
function injectStyle (ssrContext) {
  __webpack_require__("QsgM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cb270f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb270f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gMT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery"},[(_vm.getMatchedImages.length > 0)?_c('galleryComponent'):_vm._e(),_vm._v(" "),(_vm.getMatchedImages.length === 0)?_c('div',{staticClass:"no-matches-found"},[_c('h1',[_vm._v("No matches found!")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gm9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"search_result",attrs:{"fluid":""}},[_c('b-row',{staticClass:"thumbnails-layout"},[_vm._l((_vm.getMatchedImages),function(image,key){return _c('b-col',{key:key,staticClass:"thumbnailcols",attrs:{"cols":"*","sm":"5","md":"3","lg":"2","md-with-hover":""}},[_c('thumbnail',{attrs:{"image":image,"index":key}})],1)}),_vm._v(" "),_c('infinite-loading',{attrs:{"spinner":"bubbles","distance":10,"force-use-infinite-wrapper":"true"},on:{"infinite":_vm.infiniteHandler}},[_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j1cm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tagsFilter_vue__ = __webpack_require__("RT5L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9655a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tagsFilter_vue__ = __webpack_require__("ewz8");
function injectStyle (ssrContext) {
  __webpack_require__("y2do")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tagsFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9655a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tagsFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k2T+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__travel_config_inc_js__ = __webpack_require__("LvhI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_config_inc_js__ = __webpack_require__("pbG7");




var singleItem = {
  state: {
    singleImageSrc: {},
    singleImage: {},
    currentIndex: 0,
    cachedImages: []
  },
  getters: {
    getSingleImageSrc: function getSingleImageSrc(state) {
      return state.singleImageSrc;
    },
    getSingleImage: function getSingleImage(state) {
      return state.singleImage;
    },
    getCurrentIndex: function getCurrentIndex(state) {
      return state.currentIndex;
    },
    getCachedImages: function getCachedImages(state) {
      return state.cachedImages;
    }
  },
  mutations: {
    changeSingleImage: function changeSingleImage(state, payload) {
      state.singleImageSrc = payload.imageSrc;
      state.singleImage = payload.image;
      state.currentIndex = payload.currentIndex >= 0 ? payload.currentIndex : state.currentIndex;
    },
    resetCurrentIndex: function resetCurrentIndex(state) {
      state.currentIndex = null;
    },
    cacheImages: function cacheImages(state, payload) {
      state.cachedImages.push(payload);
    }
  },
  actions: {
    selectSingleItem: function selectSingleItem(context, payload) {
      context.commit('changeSingleImage', payload);
      context.dispatch('retrieveCoordinates', payload.image);
    },
    retrieveSingleItemByParams: function retrieveSingleItemByParams(context, payload) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get('' + __WEBPACK_IMPORTED_MODULE_1__travel_config_inc_js__["c" /* travelSingleItem */] + payload).then(function (data) {
        var newImage = {
          image: data.data,
          imageSrc: '' + __WEBPACK_IMPORTED_MODULE_2__images_config_inc_js__["a" /* fullImage */] + data.data._source.resource_id + '.jpg'
        };
        context.commit('changeSingleImage', newImage);
      }).catch(function (err) {
        console.warn(err);
      });
    },
    resetCurrentIndex: function resetCurrentIndex(context) {
      context.commit('resetCurrentIndex');
    },
    retrieveNextItems: function retrieveNextItems(_ref) {
      var getters = _ref.getters,
          commit = _ref.commit,
          state = _ref.state;

      state.cachedImages.length = 0;
      var searches = [-1, 1];

      searches.forEach(function (num) {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get('' + __WEBPACK_IMPORTED_MODULE_1__travel_config_inc_js__["c" /* travelSingleItem */] + getters.getMatchedImages[state.currentIndex + num]._source.resource_id).then(function (data) {
          var img = new Image();
          img.onload = function () {
            commit('cacheImages', img.src);
          };
          img.src = '' + __WEBPACK_IMPORTED_MODULE_2__images_config_inc_js__["a" /* fullImage */] + data.data._source.resource_id + '.jpg';
        }).catch(function (err) {
          console.warn(err);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (singleItem);

/***/ }),

/***/ "kDqv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kpZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      people: 1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['editFilters']), {
    changed: function changed(value) {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('editFilters', {
        filterKey: 'people',
        filterValue: value
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getFilters']))
});

/***/ }),

/***/ "kzzJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lxn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

var filterStore = {
  state: {
    orientation: 1,
    people: 1,
    timeOfDay: 1,
    colors: {},
    dates: [],
    things: []
  },
  mutations: {
    changeFilters: function changeFilters(state, payload) {
      for (var key in state) {
        if (payload.filterKey === key) {
          state[key] = payload.filterValue;
          //do a new elastic search to change find values
        }
      }
      console.log('filterStore', _this);
    }
  },
  actions: {
    editFilters: function editFilters(context, payload) {
      context.commit('changeFilters', payload);
    }
  },
  getters: {
    getFilters: function getFilters(state) {
      return state;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (filterStore);

/***/ }),

/***/ "m9Ds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_vue__ = __webpack_require__("Rfjh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44dd440f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_vue__ = __webpack_require__("XHkg");
function injectStyle (ssrContext) {
  __webpack_require__("Al55")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44dd440f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44dd440f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mtD8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "nRVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_galleryComponent_vue__ = __webpack_require__("t4Es");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gallery',
  components: {
    'galleryComponent': __WEBPACK_IMPORTED_MODULE_2__components_galleryComponent_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getMatchedImages', 'getSearchTerm', 'getThumbnailSrc', 'getThumbnailActive'])),
  data: function data() {
    return {
      displayIcon: 'local_offer',
      routeName: this.$route.path,
      searchTerm: '',
      matched: []
    };
  }
});

/***/ }),

/***/ "ndxO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oeLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"dateTime",attrs:{"fluid":""}},[_c('b-row',{staticClass:"info-header"},[_c('b-col',{staticClass:"icon",attrs:{"col":"","sm":"1"}},[_c('img',{attrs:{"src":"static/img/time-icon.png"}})]),_vm._v(" "),_c('b-col',{attrs:{"col":"","sm":"10"}},[_c('div',{staticClass:"info-title"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.createdDate)))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"col":"","lg":"1"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"11"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ovQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleItem_vue__ = __webpack_require__("zVhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d23890b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleItem_vue__ = __webpack_require__("tTrQ");
function injectStyle (ssrContext) {
  __webpack_require__("br4N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d23890b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d23890b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p0qR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pI/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tags_vue__ = __webpack_require__("a9B1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e37773_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tags_vue__ = __webpack_require__("d0JZ");
function injectStyle (ssrContext) {
  __webpack_require__("9gwk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03e37773"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e37773_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pU5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toolBar_vue__ = __webpack_require__("AUQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af23881e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toolBar_vue__ = __webpack_require__("zW5m");
function injectStyle (ssrContext) {
  __webpack_require__("LXEJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af23881e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toolBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af23881e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toolBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pbG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fullImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return thumbnailImage; });
var fullImage = "https://demoimg.miro.io/full/";
var thumbnailImage = "https://demoimg.miro.io/120_";

/***/ }),

/***/ "qVZu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qxXW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sFEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_config_inc_js__ = __webpack_require__("LvhI");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'demo',
  data: function data() {
    var _ref;

    return _ref = {
      refss: this.$refs,
      loading: false,
      thumbnailSrc: '',
      size: '200px',
      color: 'red',
      progress: 0
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'thumbnailSrc', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'progressBar', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'options', {
      strokeWidth: 4,
      easing: 'easeInOut',
      duration: 500,
      color: '#e91e63',
      trailColor: '#eee',
      trailWidth: 1,
      svgStyle: { width: '100%', height: '100%' }
    }), _ref;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
      setTimeout(function () {
        document.getElementById("autocompleteInputField").childNodes[0].childNodes[1].focus();
      }, 5);
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    },
    uploadImage: function uploadImage(e) {
      var _this = this;

      this.loading = true;
      this.progressBar = this.$refs.basicLine;
      this.progressBar.setText("Uploading");
      this.progress = 0.01;
      this.progressBar.set(0.01);
      var headers = {
        'Content-Type': 'image/jpeg'
      };
      var resizedImage = new Image();
      var reader = new FileReader();
      var thumbnail = new FileReader();
      var that = this;

      thumbnail.onload = function (e) {
        _this.thumbnailSrc = thumbnail.result;
        var canvas = document.getElementById("cvas");
        var ctx = canvas.getContext("2d");
        var img = new Image();

        img.src = thumbnail.result;
        img.onload = function () {
          var _this2 = this;

          canvas.height = canvas.width * (img.height / img.width);
          ctx.drawImage(this, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
          var blob = document.getElementById("cvas").toBlob(function (blob) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_5__travel_config_inc_js__["a" /* travelImageUpload */], blob, {
              headers: headers,
              onUploadProgress: function onUploadProgress(progressEvent) {
                if (progressEvent.loaded === progressEvent.total) {
                  that.progressBar.setText("Analysing");
                  that.progressBar.set(0.8);
                } else {
                  that.progress = progressEvent.loaded / progressEvent.total;
                  that.progressBar.set(that.progress * 0.75);
                }
              }
            }).then(function (data) {
              that.progressBar.setText("Querying");
              that.progressBar.set(1.0);
              var kwords = data.data.keywords.join(',');
              that.$router.push('/search/tags/' + kwords);
              setTimeout(function () {
                _this2.loading = false;
              }, 500);
            }).catch(function (err) {
              console.warn(err);
            });
          }, 'image/jpeg', 95);
        };
        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].dispatch('retrieveThumbnail', thumbnail.result);
      };
      thumbnail.readAsDataURL(e.target.files[0]);
      //reader.readAsArrayBuffer(e.target.files[0]);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['retrieveThumbnail']))
});

/***/ }),

/***/ "sFPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainpage_vue__ = __webpack_require__("OIay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_146346a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainpage_vue__ = __webpack_require__("1Ujn");
function injectStyle (ssrContext) {
  __webpack_require__("sjMR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-146346a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_146346a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "sjMR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t4Es":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galleryComponent_vue__ = __webpack_require__("2NTX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45342925_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_galleryComponent_vue__ = __webpack_require__("gm9L");
function injectStyle (ssrContext) {
  __webpack_require__("0ld6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45342925"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galleryComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45342925_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_galleryComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tTrQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('toolBar'),_vm._v(" "),_c('b-container',{staticClass:"single-item-container",attrs:{"fluid":""}},[(_vm.getSearchTerm)?_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.getCurrentIndex > 0),expression:"getCurrentIndex > 0"}],attrs:{"id":"singleImageLeft"},on:{"click":_vm.prevPic}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_arrow_left")])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.getCurrentIndex < _vm.getMatchedImages.length - 1),expression:"getCurrentIndex < getMatchedImages.length - 1"}],attrs:{"id":"singleImageRight"},on:{"click":_vm.nextPic}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_arrow_right")])])],1):_vm._e(),_vm._v(" "),_c('img',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.touched),expression:"touched",arg:"tap"},{name:"touch",rawName:"v-touch:swipe.left",value:(_vm.nextPic),expression:"nextPic",arg:"swipe",modifiers:{"left":true}},{name:"touch",rawName:"v-touch:swipe.right",value:(_vm.prevPic),expression:"prevPic",arg:"swipe",modifiers:{"right":true}},{name:"touch-class",rawName:"v-touch-class",value:('active-touch'),expression:"'active-touch'"},{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticStyle:{"width":"100%"},attrs:{"src":_vm.getSingleImageSrc,"alt":"","id":"singleImage"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"src":_vm.blurredImage,"alt":"","id":"blurred-image-loading"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"50px"}}),_vm._v(" "),_c('people',{attrs:{"people":_vm.getSingleImage._source.people}}),_vm._v(" "),_c('tagChips',{attrs:{"keywords":_vm.getSingleImage._source.keywords}}),_vm._v(" "),_c('colors',{attrs:{"colors":_vm.getSingleImage._source.colors}}),_vm._v(" "),_c('dateTime',{attrs:{"dateTime":_vm.getSingleImage._source.exif.created}}),_vm._v(" "),_c('location',{attrs:{"loc":_vm.getSingleImage._source.location,"places":_vm.getSingleImage._source.places}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tlXY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u2Jm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uNZE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/miro-visual-search-as-a-service.8b50355.png";

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filterStore__ = __webpack_require__("lxn2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__searchTerms__ = __webpack_require__("+1QT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__singleItem__ = __webpack_require__("k2T+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__relatedImages__ = __webpack_require__("LDSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__searchImages__ = __webpack_require__("SGXa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__singleItemMap__ = __webpack_require__("SPK0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_elasticsearch__ = __webpack_require__("P13P");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    filterStore: __WEBPACK_IMPORTED_MODULE_2__filterStore__["a" /* default */],
    searchTerms: __WEBPACK_IMPORTED_MODULE_3__searchTerms__["a" /* default */],
    singleItem: __WEBPACK_IMPORTED_MODULE_4__singleItem__["a" /* default */],
    relatedImages: __WEBPACK_IMPORTED_MODULE_5__relatedImages__["a" /* default */],
    searchImages: __WEBPACK_IMPORTED_MODULE_6__searchImages__["a" /* default */],
    singleItemMap: __WEBPACK_IMPORTED_MODULE_7__singleItemMap__["a" /* default */],
    elastic: __WEBPACK_IMPORTED_MODULE_8_vue_elasticsearch__["VueElasticStore"]
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xcBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'demodrilldown',
  data: function data() {
    return {
      returnedData: {}
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['retrieveMatchedImages', 'setSearchTerm', 'resetCurrentIndex'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getMatchedImages', 'getSearchTerm'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('retrieveMatchedImages', { result: to.params.tags, thumbnail: false }).then(function () {
      next();
    }).catch(function (err) {
      console.warn(err);
    });
  },
  created: function created() {
    window.scrollTo(0, 0);
    var tag = this.$router.history.current.params.tags;
    if (this.$router.history.current.params.tags !== this.getSearchTerm) {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('setSearchTerm', tag);
    }
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('resetCurrentIndex');
  }
});

/***/ }),

/***/ "xihx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xvyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      time: 1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['editFilters']), {
    changed: function changed(value) {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch('editFilters', {
        filterKey: 'time',
        filterValue: value
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getFilters']))
});

/***/ }),

/***/ "y2do":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z5aE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoComplete_vue__ = __webpack_require__("6zxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abb4b43c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autoComplete_vue__ = __webpack_require__("XH0R");
function injectStyle (ssrContext) {
  __webpack_require__("Qhg4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-abb4b43c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abb4b43c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autoComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zH4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_vue__ = __webpack_require__("sFEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecac851a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_vue__ = __webpack_require__("SKUE");
function injectStyle (ssrContext) {
  __webpack_require__("2ZXv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecac851a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecac851a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zUy+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zVhK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_singleItemMap__ = __webpack_require__("O/is");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_config_inc_js__ = __webpack_require__("pbG7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      singleItem: '',
      searchTerm: '',
      displayIcon: 'local_offer',
      loading: true,
      blurredImage: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['retrieveSingleItemByParams', 'selectSingleItem']), {
    touched: function touched(e) {
      console.log('touched', e);
    },
    nextPic: function nextPic() {
      if (this.getSearchTerm && this.getCurrentIndex < this.getMatchedImages.length - 1) {
        var nextImage = this.getMatchedImages[this.getCurrentIndex + 1];
        var that = this;
        this.loading = true;
        this.blurredImage = this.getCachedImages[1];
        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].dispatch('selectSingleItem', {
          imageSrc: '' + __WEBPACK_IMPORTED_MODULE_5__images_config_inc_js__["a" /* fullImage */] + nextImage._source.resource_id + '.jpg',
          image: nextImage,
          currentIndex: this.getCurrentIndex + 1
        }).then(function () {
          setTimeout(function () {
            that.$router.push('/image/' + nextImage._source.resource_id);
            that.loading = false;
          }, 800);
        });
      }
    },
    prevPic: function prevPic() {
      if (this.getSearchTerm && this.getCurrentIndex > 0) {
        var prevImage = this.getMatchedImages[this.getCurrentIndex - 1];
        var that = this;
        this.loading = true;
        this.blurredImage = this.getCachedImages[0];
        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].dispatch('selectSingleItem', {
          imageSrc: '' + __WEBPACK_IMPORTED_MODULE_5__images_config_inc_js__["a" /* fullImage */] + prevImage._source.resource_id + '.jpg',
          image: prevImage,
          currentIndex: this.getCurrentIndex - 1
        }).then(function () {
          setTimeout(function () {
            that.$router.push({ name: 'singleItem', params: { id: prevImage._source.resource_id } });
            that.loading = false;
          }, 800);
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getSingleImageSrc', 'getMatchedImages', 'getCurrentIndex', 'getSingleImage', 'getSearchTerm', 'getCachedImages'])),
  components: {
    'singleItemMap': __WEBPACK_IMPORTED_MODULE_4__components_singleItemMap__["a" /* default */]
  },
  created: function created() {
    window.scrollTo(0, 0);
    this.loading = false;
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (!from.name || from.name.name === 'demodrilldown') {
      __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].dispatch('retrieveSingleItemByParams', to.params.id).then(function (data) {
        next();
      });
    } else {
      next();
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (from.name === 'singleItem') {
      __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].dispatch('retrieveSingleItemByParams', to.params.id).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].dispatch('retrieveNextItems');
        window.scrollTo(0, 0);
        next();
      });
    } else {
      next();
    }
    window.scrollTo(0, 0);
    next();
  },
  updated: function updated() {
    document.getElementById('blurred-image-loading').style.height = this.getSingleImage._source.height / (this.getSingleImage._source.width / 950) + 'px';
  }
});

/***/ }),

/***/ "zW5m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"tool-bar",attrs:{"fluid":""}},[_c('b-row',{staticClass:"tool-bar-row",attrs:{"align-v":"center"}},[(!!_vm.getSearchTerm)?_c('b-col',{attrs:{"cols":"2"}},[_c('div',{on:{"click":_vm.backButton}},[_c('i',{staticClass:"material-icons backArrow",staticStyle:{"color":"white"}},[_vm._v("keyboard_arrow_left")])])]):_vm._e(),_vm._v(" "),(!_vm.getSearchTerm)?_c('b-col',{attrs:{"cols":"2"}},[_c('div',{on:{"click":_vm.homeButton}},[_c('md-icon',{staticClass:"md-size-3x",staticStyle:{"color":"white"}},[_vm._v("home")])],1)]):_vm._e(),_vm._v(" "),(!!_vm.getSearchTerm)?_c('b-col',{attrs:{"cols":"8"}},[_c('p',{staticClass:"searchTerms title"},[(!_vm.getThumbnailActive)?_c('md-icon',{staticClass:"displayIcon md-size-2x"},[_vm._v(_vm._s(_vm.displayIcon))]):_vm._e(),_vm._v(" "),(_vm.getThumbnailActive)?_c('img',{staticClass:"thumbnailImage",attrs:{"src":_vm.getThumbnailSrc,"alt":""}}):_vm._e(),_vm._v("  \n        "+_vm._s(_vm.searchTerm)+"\n      ")],1)]):_vm._e(),_vm._v(" "),(!_vm.getSearchTerm)?_c('b-col',{staticClass:"text-center",attrs:{"cols":"8","align-self":"center","id":"toolbar-miro"}},[_c('img',{staticClass:"miro-logo",attrs:{"src":__webpack_require__("uNZE"),"alt":"miro"}})]):_vm._e(),_vm._v(" "),(!!_vm.getSearchTerm)?_c('b-col',{attrs:{"cols":"2"}},[_c('p',{staticClass:"photo-count"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$router.history.current.name === 'singleItem'),expression:"$router.history.current.name === 'singleItem'"}]},[_c('strong',[_vm._v(_vm._s(_vm.getCurrentIndex + 1))]),_vm._v(" of\n        ")]),_vm._v(_vm._s(_vm.getImagesCount)+" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$router.history.current.name !== 'singleItem'),expression:"$router.history.current.name !== 'singleItem'"}]},[_vm._v("Photos")])])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ziF4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.aa2a204103699f092420.js